<template>
  <v-col class="calendar-informs-container">
    <v-row>
      <div class="inform-picker">
        <v-select
          v-model="selectedInform"
          :items="informsList"
          item-text="label"
          item-value="id"
          :label="informTypeText"
          color="secondary"
          item-color="secondary"
          hide-details
        ></v-select>
      </div>
      <div class="date-picker">
        <v-menu
          v-model="rangeDatePicker"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
          ref="dateRange"
          :return-value.sync="rangeDate"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateRangeLabel"
              :label="dateRangeText"
              color="secondary"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              hide-details
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="rangeDate"
            no-title
            range
            scrollable
            :locale="locale"
          >
            <v-spacer></v-spacer>
            <v-btn text color="secondary" @click="rangeDatePicker = false">
              {{ $t('common.cancel') }}
            </v-btn>
            <v-btn
              color="secondary"
              @click="
                $refs.dateRange.save(rangeDate)
                loadInform()
              "
            >
              {{ $t('inform.loadInform') }}
            </v-btn>
          </v-date-picker>
        </v-menu>
      </div>
      <v-spacer></v-spacer>
      <v-text-field
        class="search-field"
        v-model="search"
        append-icon="mdi-magnify"
        :label="searchText"
        single-line
        hide-details
        color="secondary"
      ></v-text-field>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="selectedInform === 1 ? headers : headersCount"
          :items="selectedInform === 1 ? informEvents : informCount"
          :items-per-page="-1"
          item-key="id"
          :footer-props="footerProps"
          :search="search"
          class="elevation-1"
          :no-data-text="noEventsText"
          :no-results-text="noResultsText"
          :mobile-breakpoint="0"
          :sort-by="selectedInform === 1 ? 'start' : ['count', 'leader']"
          :sort-desc="selectedInform === 1 ? false : true"
          multi-sort
        >
          <template v-slot:item.name="{ item }">
            <TextHighlight :queries="search">{{ item.name }}</TextHighlight>
          </template>
          <template v-slot:item.start="{ item }">
            <TextHighlight :queries="search">{{ item.start }}</TextHighlight>
          </template>
          <template v-slot:item.end="{ item }">
            <TextHighlight :queries="search">{{ item.end }}</TextHighlight>
          </template>
          <template v-slot:item.leadersText="{ item }">
            <TextHighlight :queries="search">{{
              item.leadersText
            }}</TextHighlight>
          </template>
          <template v-slot:item.leader="{ item }">
            <TextHighlight :queries="search">{{ item.leader }}</TextHighlight>
          </template>
          <template v-slot:item.email="{ item }">
            <TextHighlight :queries="search">{{ item.email }}</TextHighlight>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import TextHighlight from 'vue-text-highlight'
import { mapState } from 'vuex'
import { getCalendarDate, getCalendarDateFirstDayOfMonth } from '@/utils/common'
import {
  getEventsFromRageDate,
  getEventsPerLeader
} from '@/utils/calendar-informs'

export default {
  components: {
    TextHighlight
  },
  data: () => ({
    rangeDatePicker: false,
    rangeDate: [
      getCalendarDateFirstDayOfMonth(),
      getCalendarDate(new Date().getTime())
    ],
    selectedInform: 1,
    search: '',
    informEvents: [],
    informCount: [],
    locale: localStorage.getItem('bd-kol-lang') || 'es'
  }),
  created() {
    this.loadInform()
  },
  computed: {
    ...mapState({
      leaders: state => state.leaderStore.leaders,
      leadersMap: state => state.leaderStore.leadersMap,
      events: state => state.eventStore.events
    }),
    dateRangeLabel() {
      return this.rangeDate.join(' ~ ')
    },
    footerProps() {
      return {
        itemsPerPageText: this.$t('admin.itemsPerPage'),
        itemsPerPageAllText: this.$t('admin.all'),
        itemsPerPageOptions: [10, 20, 50, 100, -1]
      }
    },
    noResultsText() {
      return this.$t('admin.noResultsText')
    },
    nameText() {
      return this.$t('calendar.name')
    },
    descriptionText() {
      return this.$t('calendar.description')
    },
    assoLeadersText() {
      return this.$t('calendar.assoLeaders')
    },
    startText() {
      return this.$t('calendar.start')
    },
    endText() {
      return this.$t('calendar.end')
    },
    eventsQuantityText() {
      return this.$t('inform.eventsQuantity')
    },
    leaderText() {
      return this.$t('calendar.leader')
    },
    emailText() {
      return this.$t('fields.email')
    },
    informTypeText() {
      return this.$t('inform.type')
    },
    dateRangeText() {
      return this.$t('inform.dateRange')
    },
    searchText() {
      return this.$t('common.search')
    },
    noEventsText() {
      return this.$t('inform.noEvents')
    },
    informsList() {
      return [
        { id: 1, label: this.$t('inform.eventsList') },
        { id: 2, label: this.$t('inform.eventsPerLeader') }
      ]
    },
    headers() {
      return [
        { text: this.nameText, value: 'name', width: '200px' },
        { text: this.startText, value: 'start', width: '150px' },
        { text: this.endText, value: 'end', width: '150px' },
        { text: this.assoLeadersText, value: 'leadersText', width: '300px' },
        { text: this.descriptionText, value: 'description', width: '250px' }
      ]
    },
    headersCount() {
      return [
        { text: this.eventsQuantityText, value: 'count', width: '185px' },
        { text: this.leaderText, value: 'leader', width: '300px' },
        { text: this.emailText, value: 'email', width: '200px' }
      ]
    }
  },
  watch: {
    events() {
      this.loadInform()
    }
  },
  methods: {
    loadInform() {
      this.informEvents = getEventsFromRageDate(this.rangeDate, this.events)
      this.informCount = getEventsPerLeader(
        this.rangeDate,
        this.events,
        this.leadersMap
      )
    }
  }
}
</script>
<style lang="scss">
.calendar-informs-container {
  word-break: break-word;

  .search-field {
    margin-top: 16px;
    margin-right: 12px;
    max-width: 350px;
  }
  .inform-picker {
    width: 190px;
    margin: 12px;
  }
  .date-picker {
    width: 220px;
    margin: 12px;
  }

  @media (max-width: 599px) {
    .inform-picker,
    .date-picker {
      width: 100%;
    }
  }

  .text__highlight {
    background-color: #adeeff;
  }
}
</style>
